// extracted by mini-css-extract-plugin
export var divider = "_to-0";
export var systemMessage = "_to-1";